import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const subVendorApi = async (vendor) => {
  let url = '';
  const page = vendor?.page === 0 || vendor?.page ? vendor?.page + 1 : 1;
  if (vendor?.subVendorId && (vendor?.id !== undefined || vendor?.id !== 'undefined')) {
    url = `${env}${API_ENDPOINT.SubVendor.api + '/' + vendor.subVendorId + '?isB2B=true'}`;
  } else if (vendor?.id) {
    url = `${env}${API_ENDPOINT.SubVendor.api + '?vendorId=' + vendor?.id + '&isB2B=true' + '&status=' + (vendor?.status ? vendor?.status : '') + '&location=' + (vendor?.location ? vendor?.location : '') + '&dateFrom=' + (vendor?.dateFrom ? vendor?.dateFrom : '') + '&dateTo=' + (vendor?.dateTo ? vendor?.dateTo : '') + '&page=' + page + '&pageSize=' + (vendor?.pageSize ? vendor?.pageSize : '') + '&search=' + (vendor?.search ? vendor?.search : '')}`;
  } else if (vendor?.vendorId) {
    url = `${env}${API_ENDPOINT.SubVendor.api + '?vendorId=' + vendor?.vendorId + '&isB2B=true' + '&status=' + (vendor?.status ? vendor?.status : '') + '&location=' + (vendor?.location ? vendor?.location : '') + '&dateFrom=' + (vendor?.dateFrom ? vendor?.dateFrom : '') + '&dateTo=' + (vendor?.dateTo ? vendor?.dateTo : '') + '&page=' + page + '&pageSize=' + (vendor?.pageSize ? vendor?.pageSize : '') + '&search=' + (vendor?.search ? vendor?.search : '')}`;
  } else if (vendor?.subVendorId) {
    url = `${env}${API_ENDPOINT.SubVendor.api + '/' + vendor.subVendorId}`;
  } else {
    url = `${env}${API_ENDPOINT.SubVendor.api + '?status=' + vendor?.status + '&isB2B=true' + '&dateFrom=' + vendor?.dateFrom + '&dateTo=' + vendor?.dateTo + '&page=' + page + '&pageSize=' + vendor.pageSize}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
export const addSubVendorApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.SubVendor.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const updateSubVendorApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.SubVendor.api + '/' + data.subVendorId}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const detailSubVendorApi = async (vendor) => {
  let url = `${env}${API_ENDPOINT.SubVendor.moreApi + '/' + vendor.subVendorId}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
